(function($) {

  const check = $('body.page-template-template-fleet').length;

  if( check ) {

    // Setup archive
    const archive_controler = new ArchiveControler();
    archive_controler.register_archive_container( document.getElementById('FleetContent') );

      archive_controler.register_filter_checkboxgroup( document.getElementById('Filter_1') );
      archive_controler.register_filter_checkboxgroup( document.getElementById('Filter_2') );
      archive_controler.register_filter_checkboxgroup( document.getElementById('Filter_3') );
      archive_controler.register_filter_checkboxgroup( document.getElementById('Filter_4') );
      archive_controler.register_filter_checkboxgroup( document.getElementById('Filter_5') );
      archive_controler.register_filter_checkboxgroup( document.getElementById('Filter_6') );

      archive_controler.register_search_input( document.getElementById('Search') );
      archive_controler.register_counter( document.getElementById('Counter') );

      archive_controler.register_self_loading_classname('archive__loading');
      archive_controler.register_pillstrip_classname('archive__fleet-pillstrip');
      archive_controler.register_more_button_classname('button__more');

      archive_controler.on('change', function() {
        const elements = archive_controler.archive_container.querySelectorAll('.new');
        const tl = gsap.timeline();
        elements.forEach((element, index) => {
          tl.to({}, { 
            duration: 0.1,
            onStart: function() {
              element.classList.remove('new');
            }
          });
        });
      })

    // Dropdown with checkboxes
    jQuery('.dropdown-wrapper span').on('click', function() {
      $(this)
        .toggleClass('open')
        .next('div')
          .slideToggle(350);
    });

    // Toggle dropown panel
    jQuery('.filter-navs').on('click', function() {
      jQuery('.archive__fleet-dropdownspanel').addClass('active');
      jQuery('body').addClass('no-scroll');
      jQuery('html').addClass('no-scroll');
    });
    // Toggle dropown panel
    jQuery('.toggle-dropdownspanel.on-panel').on('click', function() {
      jQuery('.archive__fleet-dropdownspanel').removeClass('active');
      jQuery('body').removeClass('no-scroll');
      jQuery('html').removeClass('no-scroll');
    });

    // Pin
    // ScrollTrigger.create({
    //   trigger: '.archive__fleet',
    //   start: 'top top',
    //   end: 'bottom top',
    //   pin: '.archive__fleet-header',
    //   pinSpacing: false, 
    //   markers: false 
    // });

  }

})(jQuery);